import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Sales Documentation | Canny';
const Description =
  'Close more deals by informing your product team on what prospects are asking for.';
const Image = 'https://canny.io/images/canny-social.png';

export default class LandingSalesHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/use-cases/sales-documentation' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
